module.exports = __webpack_public_path__ + "static/carbon-button-primary-52953513e1ca462e8ede0dc55d9c961b.png";